export const ENGAGEMENT_MODELS = [
    {
        slug: "milestone",
        name: "Milestone-Based",
        tagline: "Fixed-scope delivery with clear milestones and predictable outcomes.",
        overview: "Best for scoped initiatives with a defined end state — migrations, launches, and platform builds where budget certainty matters as much as outcomes.",
        benefits: ["Predictable budget", "Defined acceptance criteria per milestone", "Risk premium priced up front, not hidden", "Single point of accountability"],
        governance: ["Bi-weekly steering", "Milestone acceptance gates", "Risk register maintained transparently"],
        lifecycle: ["Discovery & scoping", "Architecture & backlog", "Iterative build & test", "UAT & milestone acceptance", "Hyper-care & handover"],
        cost_visibility: "Fixed price per milestone with clearly documented change-order process. No hidden staffing swaps.",
    },
    {
        slug: "tm",
        name: "T&M (Time & Material)",
        tagline: "Elastic capacity with weekly transparency.",
        overview: "Best for evolving product roadmaps, ongoing platform teams, or when scope is inherently discovery-driven.",
        benefits: ["Flexibility to reprioritize weekly", "Transparent weekly reporting", "Elastic ramp up and down", "Skill mix tuned to real-time need"],
        governance: ["Weekly velocity report", "Named resources with defined roles", "Quarterly leadership reviews"],
        billing_logic: "Rate card per role, timesheet-based billing, and no hidden overhead. Rate cards are shared in writing.",
        reporting: ["Weekly hours & burndown", "Quarterly outcome scorecard", "Named engineer tenure tracking"],
        cost_visibility: "Weekly cost reports with per-engineer breakdown and rolling forecast for the next 4 weeks.",
    },
];

export function getEngagementBySlug(slug) {
    return ENGAGEMENT_MODELS.find((e) => e.slug === slug);
}
